import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { WorkShiftService } from '../../services/work-shift.service';

@Component({
    selector: 'app-display-work-shift',
    templateUrl: './display-work-shift.component.html',
    styleUrls: ['./display-work-shift.component.css', '../../app.component.css']
})

export class DisplayWorkShiftComponent implements OnInit {

    workShift: any = [];

    id: string;

    gwsSubs: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private workShiftService: WorkShiftService) {
        this.activatedRoute.params.subscribe(parameters => {
            
            this.id = parameters['id'];

            this.gwsSubs = this.workShiftService.getWorkShift(this.id).subscribe(workShiftObj => {
                this.gwsSubs.unsubscribe();

                this.workShift = workShiftObj;
            });
        });
    }

    ngOnInit() {

    }

}
